export default {
  GET_GRANTS_BY_NODE: 'getGrantsByNode',
  GET_GRANTS_BY_NODE_WITH_PARENTS: 'getGrantsByNodeWithParents',
  ADD_GRANT: 'addGrant',
  DELETE_GRANT: 'deleteGrant',
}
